import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DtoCostCalcAddNameVM } from '../../../Model/cost-calculation/DtoCostCalcAddNameVM';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-details',
  templateUrl: './add-details.component.html',
  styleUrl: './add-details.component.scss'
})
export class AddDetailsComponent {
  @Input() childForm!: FormGroup;
  @Input() formGroupName!: string;
  @Input() CostCalc?: DtoCostCalcAddNameVM;
  title?: string = '';

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    this.title = this.CostCalc?.name;
    this.childForm.get([this.formGroupName, 'id'])?.setValue(this.CostCalc?.id);
    this.childForm.get([this.formGroupName, 'name'])?.setValue(this.CostCalc?.name);
  }

  GetFocusPlaceholder(cat?: any, key?: any): string {
    let translationKey = "";
    this.translateService.get(key).subscribe((translation: any) => {
      translationKey = translation;
    });

    return cat.placeholder = translationKey;
  }
}
